import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { MicrositeConfiguratorComponent } from './micrositeConfigurator.component';
import { TranslatePipeModule} from '../translate/translate.pipe.module';
import {FileUploadModule} from 'ng2-file-upload';
import {MaterialChipsInputModule} from '../project/tags/materialChipsInput.module';
import {RibbonModule} from '../ribbon/ribbon.module';
import {ContentPreviewModule} from '../project/emailPreview/content-preview.module';
import {GenericModalModule} from '../modal/generic-modal.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSelectModule,
        NgxSelectModule,
        TranslatePipeModule,
        FileUploadModule,
        MaterialChipsInputModule,
        RibbonModule,
        ContentPreviewModule,
        GenericModalModule
    ],
  declarations: [MicrositeConfiguratorComponent],
  providers: [],
  exports: [MicrositeConfiguratorComponent]
})

export class MicrositeConfiguratorModule {

}
